import React from 'react'
import { useTheme } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid-pro'
import { GridApiPro } from '@mui/x-data-grid-pro/models/gridApiPro'
import { useMuiTheme } from 'src/config/muiProvider/MuiProvider'
import XGrid from '../../../../../components/XGrid/XGrid'
import { useDesktopWindowContext } from '../../../../../pages/desktop/components/desktopWindow/DesktopWindowRenderer'
import { RatesDataGridRow } from '../contexts/ratesDataGrid/RatesDataGridContext.types'
interface Props {
  gridApiRef: React.MutableRefObject<GridApiPro>
  rows: (RatesDataGridRow & { index: number })[]
  columns: GridColDef[]
  containerEl: HTMLDivElement | undefined
}
const VirtualizedGrid: ReactFC<Props> = ({ gridApiRef, rows, columns }) => {
  const { windowId } = useDesktopWindowContext()
  const { isDarkMode } = useMuiTheme()
  const theme = useTheme()

  return (
    <XGrid
      columnHeaderHeight={0}
      className={`table-${windowId}`}
      rows={rows}
      columns={columns}
      pinnedColumns={{
        left: ['col1', 'col2']
      }}
      // disableExtendRowFullWidth
      // disableMultipleSelection
      // disableSelectionOnClick
      disableColumnMenu
      hideFooter
      getRowClassName={({ row }) =>
        `ratesDataGrid-row-${row.type.toLowerCase()}`
      }
      apiRef={gridApiRef}
      isRowSelectable={() => false}
      // autoHeight
      sx={{
        // position: "absolute",
        // width: "100%",
        // zIndex: 0,
        '& .MuiDataGrid-columnSeparator': {
          display: 'none !important'
        },
        '& .Avail-datagrid-header-bold *': {
          fontWeight: '900'
        },
        '& [class*=-MuiDataGrid-pinnedColumn]': {
          boxShadow: 'none !important'
        },
        '& .MuiDataGrid-row': {
          '&:not(.ratesDataGrid-row-hotel)': {
            '.MuiDataGrid-cell': {
              borderRight: '1px solid #c4c4c4'
            }
          }
        },
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
          outline: 'none'
        },
        '& .cellData': {
          padding: '0'
        },
        '& .weekendCell': {
          bgcolor: 'primary.100'
        },
        '& .editedCell': {
          bgcolor: '#6ee872'
        },
        '& .ratesDataGrid-row-hotel': {
          bgcolor: `${theme.palette.primary.main} !important`,
          '& .MuiTypography-root': {
            color: 'white !important'
          },
          '.MuiDataGrid-cell': {
            border: 'none'
          }
        },
        '& .ratesDataGrid-row-room_type': {
          bgcolor: `${
            theme.palette.primary[isDarkMode ? 'dark' : 'light']
          } !important`,
          boxSizing: 'border-box',
          '.MuiDataGrid-cell': {
            // border: 'none'
          },
          '.MuiTypography-root': {
            color: 'text.primary'
          }
        },
        '& .notEditableCell': {
          color: '#afafaf',
          ':hover': {
            cursor: 'not-allowed'
          }
        }
      }}
    />
  )
}
export default React.memo(VirtualizedGrid)
